<!--Mobile Header-->
<fgb-page-header [pageTitle]="'rewards.page.title'"></fgb-page-header>

<div *ngIf="purchasedItemList && purchasedItemList.length > 0; else noPurchase">
  <div class="d-block d-lg-flex pt-lg-3 justify-content-center align-items-center">
    <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3 text-white">
      <div class="d-lg-flex d-block">
        <div>
          <div class="text-success mb-0 fw-bold font-size-18 text-left">
            <ng-container *ngIf="marketplaceItemType == 'Marketplace'">{{
              'marketplace.purchase.success' | translate
            }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'Event'">{{ 'events.purchase.success' | translate }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'Product'">{{ 'products.purchase.success' | translate }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'MerchantValue'">
              <span class="text-success">
                {{ 'marketplace.purchase.merchant.success' | translate }}
              </span>
            </ng-container>
          </div>
          <p class="mb-0 text-white font-size-14 text-left pe-lg-4 rewards-success-description">
            <ng-container *ngIf="marketplaceItemType == 'Marketplace'">{{
              'marketplace.purchase.email.confirmation' | translate
            }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'Event'">{{
              'events.purchase.email.confirmation' | translate
            }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'Product'">{{
              'products.purchase.email.confirmation' | translate
            }}</ng-container>
            <ng-container *ngIf="marketplaceItemType == 'MerchantValue'">{{
              'merchant.purchase.email.confirmation' | translate
            }}</ng-container>
          </p>

          <div class="d-flex justify-content-between border-0 mt-4">
            <a class="btn btn-primary confirm-btn fw-bold" [routerLink]="['/rewards/wallet']">{{
              'rewards.back.to.wallet' | translate
            }}</a>
          </div>
        </div>

        <div class="border rounded payment-details d-lg-flex align-items-center">
          <div *ngFor="let purchasedItem of purchasedItemList" class="w-100">
            <div class="d-lg-flex d-block">
              <div class="me-4 mb-lg-0 mb-3">
                <img
                  class="purchase-success-image rounded"
                  src="{{ purchasedItem.ItemImageURL || defaultItemImageUrl | contentImage: '7' : 'marketplace' }}"
                  alt="{{ purchasedItem.ImageURL }}"
                  [useDefault]="true"
                  loyaltyType="marketplace"
                  draggable="false"
                />
              </div>
              <div>
                <ng-container>
                  <div class="font-size-14 fw-bold mb-3">
                    {{ purchasedItem.DisplayName || defaultItemName || 'Display Name' }}
                  </div>
                </ng-container>
                <!--Attributes-->
                <ng-container *ngFor="let attribute of attributes">
                  <div class="d-flex align-items-center mt-2">
                    <span class="font-size-12 rewards-details-spacing">{{ attribute.AttributeName }}:</span>
                    <span
                      class="fw-bold font-size-14"
                      fgbclAttributeTransValue
                      [attributeList]="purchasedItem.Attributes"
                      [attributeDataOrId]="attribute.RewardValueId"
                    ></span>
                  </div>
                </ng-container>
                <!--Custom Fields-->
                <ng-container *ngFor="let customfield of customFields">
                  <div class="d-flex align-items-center mt-2">
                    <span class="font-size-12 rewards-details-spacing">{{ customfield.DisplayName }}:</span>
                    <span class="fw-bold font-size-14"> {{ customfield.Value }}</span>
                  </div>
                </ng-container>
                <!--Quantity-->
                <div class="d-flex align-items-center mt-2">
                  <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.quantity' | translate }}</span>
                  <span class="fw-bold font-size-14">{{ quantity || purchasedItem.ItemCount }}</span>
                </div>
                <!--Merchant-->
                <ng-container *ngIf="marketplaceItemType == 'MerchantValue' && purchasedItem.TotalMerchantPrice > 0">
                  <div class="d-flex align-items-center mt-2">
                    <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.merchant.used' | translate }}</span>
                    <span class="fw-bold font-size-14">${{ (purchasedItem.TotalMerchantPrice / 100).toFixed(2) }}</span>
                  </div>
                </ng-container>
                <!--Price-->
                <ng-container *ngIf="marketplaceItemType != 'MerchantValue'">
                  <div class="d-flex align-items-center mt-2" *ngIf="purchasedItem.EcashValue <= 0">
                    <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.points.used' | translate }}</span>
                    <span *ngIf="price > 0" class="fw-bold font-size-14"
                      >{{ price | number }} {{ 'marketplace.points.value.pts' | translate }}</span
                    >
                    <span *ngIf="price == 0" class="fw-bold font-size-14"> {{ 'fgbcl.marketplace.item.free' | translate }}</span>
                  </div>
                </ng-container>
                <!--Ecash-->
                <div class="col-6" *ngIf="purchasedItem.EcashValue > 0">
                  <div class="mb-2 d-flex align-items-center">
                    <span class="mt-3 font-size-12">{{ 'marketplace.ecash.used' | translate }}</span>
                  </div>
                </div>
                <div class="col-6" *ngIf="purchasedItem.EcashValue > 0">
                  <div class="mb-2 d-flex align-items-center">
                    <span class="font-size-14 pe-2 fw-bold">{{
                      (quantity * purchasedItem.EcashValue) / 100 | FortressCurrencyPipe
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngFor="let purchasedItem of purchasedItemList">
              <div class="mx-auto mb-2 mt-3 border-0" *ngIf="purchasedItem.ProcessProviderId == ProcessProvider.Download">
                <a
                  class="d-flex align-items-center justify-content-center btn btn-primary w-100 fw-bold text-white"
                  (click)="downloadPurchasedItem(purchasedItemLogId)"
                >
                  <span class="font-size-14">{{ 'download.rewards.item' | translate }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noPurchase>
  <div class="text-center p-5">{{ 'no.purchased.item.found' | translate }}</div>
</ng-template>
